import React from 'react';
import {
  WrenchIcon,
  ToolboxIcon,
  ToolsIcon,
  LanguageIcon,
  ClockIcon,
  UserHardHatIcon,
} from 'components/icons';
import { JobsiteAnnouncement } from 'apollo/generated/client-operations';
import { AnnouncementSection } from './AnnouncementSection';
import { AttributeDescription } from './AttributeDescription';
import {
  getSiteAccessStatusDescription,
  selectedContractorsList,
  selectedTradesList,
  selectedTitlesList,
  selectedLanguagesList,
} from './utils';

export function AnnouncementFilters({
  announcement,
}: {
  announcement: Partial<JobsiteAnnouncement>;
}): React.ReactElement {
  return (
    <AnnouncementSection id="filters" title="Filters">
      <AttributeDescription
        icon={ToolboxIcon}
        label="Jobsite(s)"
        values={announcement.jobsites?.edges?.map((edge) => edge?.node?.name)}
      />
      <AttributeDescription
        icon={WrenchIcon}
        label="Contractor(s)"
        values={selectedContractorsList(announcement)}
      />
      <AttributeDescription
        icon={ToolsIcon}
        label="Trade(s)"
        values={selectedTradesList(announcement)}
      />
      <AttributeDescription
        icon={UserHardHatIcon}
        label="Title(s)"
        values={selectedTitlesList(announcement)}
      />
      <AttributeDescription
        icon={LanguageIcon}
        label="Language(s)"
        values={selectedLanguagesList(announcement)}
      />
      <AttributeDescription
        icon={ClockIcon}
        label="Site Access Status"
        value={getSiteAccessStatusDescription(announcement)}
      />
    </AnnouncementSection>
  );
}
